import { TextField } from 'src/components/TextField';

import { useClientVisitFilterLabels } from './useClientVisitFilterLabels';

interface VisitFilterCountFieldProps {
  label?: string;
  value?: number;
  onChange: (value: number | undefined) => void;
  error?: boolean;
}

export const VisitFilterCountField = ({
  label,
  value,
  onChange,
  error = false,
}: VisitFilterCountFieldProps) => {
  const { visitCountLabel } = useClientVisitFilterLabels();

  return (
    <TextField
      type="number"
      label={label ?? visitCountLabel}
      value={value ?? ''}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === '') {
          onChange(undefined);
          return;
        }

        const parsed = Number(raw);
        onChange(Number.isFinite(parsed) ? parsed : undefined);
      }}
      slotProps={{
        htmlInput: { min: 0, step: 1 },
      }}
      error={error}
    />
  );
};
